import { Link } from 'react-router-dom';

const columns = [
  {
    title: '快速导航',
    links: [
      { label: '平台导航大全', to: '/directory' },
      { label: '论坛社区汇总', to: '/forums' },
      { label: '发布指南', to: '/guide' },
      { label: '常见问题', to: '/#faq' },
    ],
  },
  {
    title: '热门分类',
    links: [
      { label: '综合爆料门户', to: '/directory?category=general' },
      { label: '民生消费维权', to: '/directory?category=rights' },
      { label: '财经金融观察', to: '/directory?category=finance' },
      { label: '城市本地', to: '/directory?category=city' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '关于我们', to: '/about' },
      { label: '内容原则', to: '/about#principles' },
      { label: '联系我们', to: '/contact' },
      { label: '线索投稿', to: '/contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-20 bg-primary-900 text-background-100">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-megaphone-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold">爆料网上</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200">
              聚合全网热门爆料网站与论坛社区的导航门户。我们把分散的发布入口按类别整理清楚，
              让你少走弯路，找到真正匹配的渠道。
            </p>
            <div className="mt-5 flex items-center gap-3 text-sm text-background-200">
              <i className="ri-mail-line text-accent-300"></i>
              <a href="mailto:hello@baoliao-online.example.com" className="hover:text-background-50 transition-colors cursor-pointer">
                hello@baoliao-online.example.com
              </a>
            </div>
            <p className="mt-4 flex items-start gap-2 rounded-md bg-primary-800/60 px-3 py-2.5 text-xs leading-relaxed text-background-200">
              <i className="ri-information-line mt-0.5 text-accent-300"></i>
              本站仅提供导航与信息整理，不直接受理线索，也不对第三方平台的内容负责。
            </p>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
                {column.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={`${column.title}-${link.label}`}>
                    <Link
                      to={link.to}
                      className="whitespace-nowrap text-sm text-background-200 transition-colors hover:text-accent-300 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-700 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 爆料网上 · 内容导航平台，请理性发布、依法维权</p>
          <p className="flex flex-wrap items-center gap-4">
            <span>收录信息仅供参考，请自行核实</span>
            <button
              type="button"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="flex items-center gap-1 whitespace-nowrap text-background-200 transition-colors hover:text-accent-300 cursor-pointer"
            >
              <i className="ri-arrow-up-line"></i>返回顶部
            </button>
          </p>
        </div>
      </div>
    </footer>
  );
}